import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navLinks = [
  { label: "首页", to: "/" },
  { label: "萌系漫画", to: "/category/mengxi" },
  { label: "甜宠漫画", to: "/category/tianchong" },
  { label: "恋爱漫画", to: "/category/lianai" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === "/";
  const transparent = isHome && !scrolled;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const onSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(`/category/all${q ? `?q=${encodeURIComponent(q)}` : ""}`);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        transparent ? "bg-transparent" : "bg-background-50/95 backdrop-blur border-b border-background-200"
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
              <i className="ri-ghost-smile-line text-xl" />
            </span>
            <span
              className={`font-heading text-xl ${transparent ? "text-background-50" : "text-primary-600"}`}
            >
              可可漫画网
            </span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex">
            {navLinks.map((l) => {
              const active = l.to === "/" ? location.pathname === "/" : location.pathname.startsWith(l.to);
              return (
                <Link
                  key={l.to}
                  to={l.to}
                  className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                    active
                      ? "bg-primary-100 text-primary-700"
                      : transparent
                        ? "text-background-50 hover:bg-background-50/20"
                        : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  {l.label}
                </Link>
              );
            })}
          </nav>

          <div className="flex items-center gap-2">
            <form
              onSubmit={onSearch}
              className={`hidden items-center overflow-hidden rounded-full border px-3 lg:flex ${
                transparent ? "border-background-50/40 bg-background-50/15" : "border-background-200 bg-background-100"
              }`}
            >
              <i className={`ri-search-line text-sm ${transparent ? "text-background-50/80" : "text-foreground-500"}`} />
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索漫画、作者、标签"
                aria-label="站内搜索"
                className={`w-40 bg-transparent px-2 py-2 text-sm outline-none placeholder:text-foreground-400 ${
                  transparent ? "text-background-50" : "text-foreground-800"
                }`}
              />
            </form>

            <Link
              to="/#faq"
              className="hidden whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600 md:block"
            >
              每日更新
            </Link>

            <button
              onClick={() => setOpen((v) => !v)}
              aria-label="打开菜单"
              className={`flex h-10 w-10 items-center justify-center rounded-full md:hidden ${
                transparent ? "text-background-50" : "text-foreground-800"
              }`}
            >
              <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`} />
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="rounded-lg px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100"
              >
                {l.label}
              </Link>
            ))}
            <form onSubmit={onSearch} className="mt-2 flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3">
              <i className="ri-search-line text-sm text-foreground-500" />
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索漫画、作者、标签"
                className="w-full bg-transparent py-2.5 text-sm outline-none"
              />
            </form>
          </div>
        </div>
      )}
    </header>
  );
}